import React, { Component } from "react";
import Button from "../components/Button";
import { randomArrayElement } from "../utils/random";
import GameSetting from "../config/gameMentalRotation";

import image_level1_q1 from "../static/images/mental_rotaion/level1_q1.png";
import image_level1_q1_correct from "../static/images/mental_rotaion/level1_q1_correct.png";
import image_level1_q1_wrong from "../static/images/mental_rotaion/level1_q1_wrong.png";
import image_level1_q2 from "../static/images/mental_rotaion/level1_q2.png";
import image_level1_q2_correct from "../static/images/mental_rotaion/level1_q2_correct.png";
import image_level1_q2_wrong from "../static/images/mental_rotaion/level1_q2_wrong.png";
import image_level2_q1 from "../static/images/mental_rotaion/level2_q1.png";
import image_level2_q1_correct from "../static/images/mental_rotaion/level2_q1_correct.png";
import image_level2_q1_wrong from "../static/images/mental_rotaion/level2_q1_wrong.png";
import image_level2_q2 from "../static/images/mental_rotaion/level2_q2.png";
import image_level2_q2_correct from "../static/images/mental_rotaion/level2_q2_correct.png";
import image_level2_q2_wrong from "../static/images/mental_rotaion/level2_q2_wrong.png";
import image_level3_q1 from "../static/images/mental_rotaion/level3_q1.png";
import image_level3_q1_wrong from "../static/images/mental_rotaion/level3_q1_wrong.png";
import image_level3_q2 from "../static/images/mental_rotaion/level3_q2.png";
import image_level3_q2_wrong from "../static/images/mental_rotaion/level3_q2_wrong.png";
import image_level3_q3 from "../static/images/mental_rotaion/level3_q3.png";
import image_level3_q3_correct from "../static/images/mental_rotaion/level3_q3_correct.png";
import image_level3_q4 from "../static/images/mental_rotaion/level3_q4.png";
import image_level3_q4_correct from "../static/images/mental_rotaion/level3_q4_correct.png";
import Howtoplay from "../components/Howtoplay";
import Waiting from "../components/Waiting";
import Passpracetice from "../components/Passpracetice";
import Game from "../containers/Game";
import StatusGame from "../components/StatusGame";
import styles from "./gamementalrotation.module.css";
import IntroGame from "../components/IntroGame";
import { GameData } from "../containers/GameContainer";
import ButtonNextLevel from "../components/ButtonNextLevel";
import ButtonNextGame from "../components/ButtonNextGame";
import { useData } from "../contexts/DataContext";
import CountdownTimer from "../components/CountdownTimer";
import LevelResult from "../components/LevelResult";
import ButtonEndGame from "../components/ButtonEndGame";
import ModalEndGame from "../components/ModalEndGame";

const generateQuestion = (answer, pic1, pic2) => ({
  answer,
  pic1,
  pic2,
});
const QuestionPool = [
  [
    generateQuestion("same", image_level1_q1, image_level1_q1_correct),
    generateQuestion("not_same", image_level2_q2, image_level2_q2_wrong),
    generateQuestion("same", image_level3_q3, image_level3_q3_correct),
  ],
  [
    generateQuestion("same", image_level1_q1, image_level1_q1_correct),
    generateQuestion("not_same", image_level1_q1, image_level1_q1_wrong),
    generateQuestion("same", image_level1_q2, image_level1_q2_correct),
    generateQuestion("not_same", image_level1_q2, image_level1_q2_wrong),
  ],
  [
    generateQuestion("same", image_level2_q1, image_level2_q1_correct),
    generateQuestion("not_same", image_level2_q1, image_level2_q1_wrong),
    generateQuestion("same", image_level2_q2, image_level2_q2_correct),
    generateQuestion("not_same", image_level2_q2, image_level2_q2_wrong),
  ],
  [
    generateQuestion("not_same", image_level3_q1, image_level3_q1_wrong),
    generateQuestion("not_same", image_level3_q2, image_level3_q2_wrong),
    generateQuestion("same", image_level3_q3, image_level3_q3_correct),
    generateQuestion("same", image_level3_q4, image_level3_q4_correct),
  ],
];

class GameMentalRotation extends Component {
  constructor() {
    super();

    // game loop
    this.animationID = null;
    this.lastUpdate = null;
    this.questionShowAt = null;

    // game state
    this.state = {
      id: "4",
      showLevel: false,
      showIntro: true,
      showHowtoplay: false,
      passLevel: false,
      action: "cooldown",
      level: 0,
      round: 0,
      indexPracetice: 0,
      isModalEndGame: false,
      result: Array(GameSetting.level.length).fill([]),
      question: null,
    };
  }

  restartGame() {
    this.setState({
      showIntro: false,
      showHowtoplay: true,
      level: 0,
      round: 0,
      indexPracetice: 0,
      result: Array(GameSetting.level.length).fill([]),
    });
  }

  startGame() {
    this.setState({
      showHowtoplay: false,
      showLevel: false,
    });
    this.animationID = requestAnimationFrame((now) => this.gameLoop(now));
  }

  showHowtoPlay() {
    this.setState({
      showIntro: false,
      showHowtoplay: true,
    });
  }

  gameLoop(now) {
    if (!this.lastUpdate) {
      this.lastUpdate = now;
    }

    const delta = now - this.lastUpdate;
    const levelSetting = GameSetting.level[this.state.level];

    switch (this.state.action) {
      case "cooldown":
        if (delta > levelSetting.cooldownTime) {
          let q = [];
          if (levelSetting.practice) {
            q = QuestionPool[0][this.state.indexPracetice];
            this.setState({
              indexPracetice: this.state.indexPracetice + 1,
            });
          } else {
            q = randomArrayElement(QuestionPool[this.state.level]);
          }
          this.setState({
            question: q,
            action: "play",
          });
          this.lastUpdate = now;
        }
        break;

      case "play":
        if (delta > levelSetting.displayTime) {
          this.nextRound("timeout");
          this.lastUpdate = now;
        }
        break;

      default:
    }

    if (this.animationID) {
      this.animationID = requestAnimationFrame((now) => this.gameLoop(now));
    }
  }

  nextRound(roundResult, responseTime = 0) {
    const levelSetting = GameSetting.level[this.state.level];

    this.setState(
      (state) => ({
        question: null,
        action: "cooldown",
        result: Object.assign([], state.result, {
          [this.state.level]: [
            ...state.result[this.state.level],
            {
              result: roundResult,
              responseTime,
            },
          ],
        }),
      }),
      () => {
        if (this.state.round === levelSetting.round - 1) {
          // next level
          this.nextLevel();
        } else {
          // next round
          this.setState((state) => ({
            round: state.round + 1,
          }));
        }
      }
    );
  }

  clickAnswer(ans) {
    // clear timer, so it doesn't wait for displayTime
    this.lastUpdate = null;
    const now = new Date();
    this.nextRound(
      ans === this.state.question.answer ? "correct" : "wrong",
      now - this.questionShowAt
    );
  }

  nextLevel() {
    const levelSetting = GameSetting.level[this.state.level];

    cancelAnimationFrame(this.animationID);
    this.animationID = null;
    this.lastUpdate = null;


    const levelScore =
      levelSetting.score *
      this.state.result[this.state.level].reduce(
        (sum, cur) => sum + (cur.result === "correct" ? 1 : 0),
        0
      );
    this.setState((state) => ({
      round: 0,
      level: state.level + 1,
      showLevel: true,
      passLevel: levelScore >= (levelSetting.passScore ?? 0),
    }));
  }

  async endGame() {
    this.props.submitResult(this.state.result);
    let data = {
      [this.state.id]: this.state.result
        .filter((result, index) => index !== 0 && result.length > 0) 
        .map(result => 
         result.map((answer,no) => ({
            no,
            result: answer.result,
            responseTime: answer.responseTime
          }))
        )
    };
    await this.props.updateAllResult(data);
    this.props.forceEndGame();
  }

  nextGame() {
    this.props.submitResult(this.state.id, this.state.result);
    let data = {
      [this.state.id]: this.state.result
        .filter((result, index) => index !== 0 && result.length > 0) 
        .map(result => 
         result.map((answer,no) => ({
            no,
            result: answer.result,
            responseTime: answer.responseTime
          }))
        )
    };
    this.props.updateAllResult(data);
    this.props.navigateNextPage();
  }

  componentDidUpdate(_, prevState) {
    if (
      prevState.action !== this.state.action &&
      this.state.action === "play"
    ) {
      this.questionShowAt = new Date();
    }
  }

  render() {
    const levelSetting = GameSetting.level[this.state.level];
    const score_default = GameSetting.level[1].score;

    if (this.state.showIntro) {
      return (
        <IntroGame icon={GameData[3].gamePic} headname="เกมทดสอบที่ 4 :">
          <Button onClick={() => this.showHowtoPlay()}>ทำการทดสอบ</Button>
        </IntroGame>
      );
    }

    if (this.state.showHowtoplay) {
      return (
        <div>
          <Howtoplay id={this.state.id} />
          <Button onClick={() => this.startGame()}>ทดลองเล่น</Button>
        </div>
      );
    }
    if (this.state.showLevel) {
      const prevLevelSetting = GameSetting.level[this.state.level - 1];
      const levelScore =
        score_default *
        this.state.result[this.state.level - 1].reduce(
          (sum, cur) => sum + (cur.result === "correct" ? 1 : 0),
          0
        );
      const totalmilliTime = this.state.result[this.state.level - 1].reduce(
        (sum, item) => {
          const responseTime =
            item.responseTime === 0
              ? prevLevelSetting.displayTime
              : item.responseTime;
          return sum + responseTime;
        },
        0
      );
      const totalTime = (
        totalmilliTime /
        prevLevelSetting.round /
        1000
      ).toFixed(2);
      return (
        <div className={styles.passpracetice}>
          {this.state.isModalEndGame && (
            <ModalEndGame
              onClose={() => this.endGame()}
              onCancel={() => this.setState({ isModalEndGame: false })}
            />
          )}
          {prevLevelSetting.practice ? (
            <>
              {this.state.passLevel ? (
                <Passpracetice pass={this.state.passLevel}>
                  คุณผ่านการทดลองเล่นแล้ว ต่อไปคือการทดสอบจริง
                </Passpracetice>
              ) : (
                <>
                  <Passpracetice pass={this.state.passLevel}>
                    คุณยังไม่ผ่านการทดลองเล่น ต้องการทดลองเล่นเกมนี้อีกครั้งไหม
                  </Passpracetice>
                  <Button onClick={() => this.restartGame()}>
                    ทดลองเล่นอีกครั้ง
                  </Button>
                </>
              )}
            </>
          ) : (
            <>
              {this.state.passLevel ? (
                <>
                  <StatusGame status={"Pass"}>
                    ยินดีด้วย คุณผ่านการทดสอบ <br />
                    {prevLevelSetting.name} แล้ว
                    <br />
                    มาทดสอบระดับต่อไปกัน
                  </StatusGame>
                  <LevelResult
                    name={"Mental rotation task"}
                    score={levelScore}
                    fullscore={prevLevelSetting.round}
                    time={totalTime}
                  />
                </>
              ) : (
                <>
                  <StatusGame status={"Fail"}>
                    คุณไม่ผ่านการทดสอบ {prevLevelSetting.name} <br></br>
                    ไม่ต้องเสียใจนะ<br></br>
                    ยังมีเกมที่ 5 รอคุณอยู่
                  </StatusGame>
                  <LevelResult
                    name={"Mental rotation task"}
                    score={levelScore}
                    fullscore={prevLevelSetting.round}
                    time={totalTime}
                  />
                </>
              )}
            </>
          )}
          {(this.state.passLevel &&
            this.state.level < GameSetting.level.length) ||
          prevLevelSetting.practice ? (
            <ButtonNextLevel
              onClick={() => this.startGame()}
              Nextlevel={this.state.level}
            >
              {prevLevelSetting.practice
                ? this.state.passLevel
                  ? "เริ่มการทดสอบ"
                  : "ไม่ ฉันต้องการไปเริ่มทำการทดสอบ"
                : "ทดสอบ"}
            </ButtonNextLevel>
          ) : (
            <>
              <ButtonNextGame onClick={() => this.nextGame()}>
                ทดสอบเกมต่อไป
              </ButtonNextGame>
              <ButtonEndGame
                onClick={() => this.setState({ isModalEndGame: true })}
              >
                จบการทำแบบทดสอบ
              </ButtonEndGame>
            </>
          )}
        </div>
      );
    }

    return (
      <>
        {this.state.action === "play" ? (
          <div className={styles.body}>
            <div className={styles.timer}>
              <CountdownTimer initialTime={levelSetting.displayTime} />
            </div>
            <Game
              name={levelSetting.name}
              round={this.state.round}
              levelRound={levelSetting.round}
              id={this.state.id}
              headq={`กรุณาเลือกคำตอบ`}
            >
              <div className={styles.bodyquestion}>
                <div className={styles.question}>
                  <QuestionPicture pic={this.state.question.pic1} />
                  <QuestionPicture pic={this.state.question.pic2} />
                </div>
              </div>
              <div className={styles.answerbody}>
                <div
                  className={styles.answersame}
                  onClick={() => this.clickAnswer("same")}
                >
                  ภาพเดียวกัน
                </div>
                <div
                  className={styles.answernotsame}
                  onClick={() => this.clickAnswer("not_same")}
                >
                  คนละภาพ
                </div>
              </div>
            </Game>
          </div>
        ) : (
          <Waiting />
        )}
      </>
    );
  }
}

export const QuestionPicture = ({ pic }) => (
  <img className={styles.questionpic} src={pic} alt={pic} />
);

const WrapperGameMentalRotation = (props) => {
  const { id ,updateAllResult} = useData();

  return <GameMentalRotation guid={id} updateAllResult={updateAllResult} {...props} />;
};

export default WrapperGameMentalRotation;
